import { StringBundle } from '../localizer/stringBundle'

export const strings = {
  bundles: [StringBundle.BTF],
  strings: ['AVOD_DP_E_error_text', 'AVOD_DP_E_error_ok'] as const,
}
